import { render, staticRenderFns } from "./InputRadioExercise.vue?vue&type=template&id=075b5b40&scoped=true"
import script from "./InputRadioExercise.vue?vue&type=script&lang=js"
export * from "./InputRadioExercise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075b5b40",
  null
  
)

export default component.exports